import React from "react";
import { Text } from "../../../services/visualLibraryService";
import { i18n } from "../../../services/i18nService";
import { withAppState } from "../../../state";
import {
  ParentalWrapper,
  ListItemWrapper,
  Spacer,
  IconWrapperStyled,
  LockIconWrapperStyled,
  IconStyled,
  ImageStyled,
  ProfileNameStyled,
  SubHeaderTextStyled,
  KidsProfileLogoContainer,
  KidsProfileLogo
} from "../styles/Styled";
import ItemSelector from "../../../components/MultipleProfiles/EditProfile/ItemSelector/ItemSelector";
import { MANAGE_PROFILE } from "../Settings";
import { isLowEndLG } from "../../../utils/checkLgNewModel";

let currentIndex = 0;
export const ManageProfile = withAppState(props => {
  const isProfileLocked = props.isLocked || props.isKidLockEnabled;

  function scrollUpDown(event) {
    
    if(isLowEndLG()) return;

    if (event.deltaY > 0) {
      // down wheel move
      currentIndex =
        currentIndex === props.editProfileItemsList.length - 1
          ? currentIndex
          : (currentIndex + 1) % props.editProfileItemsList.length;
      props.onWheelUpDownManageProfile(currentIndex, MANAGE_PROFILE);
    } else if (event.deltaY < 0) {
      // up wheel moves
      currentIndex =
        currentIndex === 0
          ? currentIndex
          : (currentIndex - 1 + props.editProfileItemsList.length) % props.editProfileItemsList.length;
      props.onWheelUpDownManageProfile(currentIndex, MANAGE_PROFILE);
    }
  }
  return (
    <ParentalWrapper>
      <IconWrapperStyled>
        <ImageStyled src={props.profileImage.currentAvatar} />
        <KidsProfileLogoContainer>
          {props?.isKidsProfile?.toLowerCase() === "kids" && (
            <KidsProfileLogo src="/images/icons/kids-profile.png" alt="" />
          )}
        </KidsProfileLogoContainer>
      </IconWrapperStyled>
      <LockIconWrapperStyled>
        <ProfileNameStyled rank="1" text={props.profileName} size="large" />
        {isProfileLocked && <IconStyled width="small" height="default" name="lock" />}
      </LockIconWrapperStyled>
      <SubHeaderTextStyled
        text={i18n.get("pages.settings.manageProfile.profileManagementSubText")}
        type="greyLight"
        size="small"
      />
      {/* <Spacer mb={1} /> */}
      <ListItemWrapper
        onWheel={e => {
          scrollUpDown(e);
        }}
      >
        <ItemSelector
          items={props.editProfileItemsList}
          selectedIndex={0}
          focusName={MANAGE_PROFILE}
          stateActions={props.parentProps.stateActions}
          setFocus={props.parentProps.setFocus}
          profileImage={props.profileImage}
          getSelectedAvatar={props.getSelectedAvatar}
          onItemSelected={item => props.onClick(item)}
          onUp={props.onUpManageProfile}
        />
      </ListItemWrapper>
    </ParentalWrapper>
  );
});
